import axiosInstance from '../lib/axios'
import { API_ENDPOINTS } from '../constants/api'
import type { Property, PropertyCreate, PropertyUpdate } from '../types/api.types'

export const propertiesService = {
  async getAll(): Promise<Property[]> {
    const { data } = await axiosInstance.get<Property[]>(API_ENDPOINTS.PROPERTIES)
    return data
  },

  async getById(id: number): Promise<Property | null> {
    try {
      const { data } = await axiosInstance.get<Property>(API_ENDPOINTS.PROPERTY_BY_ID(id))
      return data
    } catch {
      return null
    }
  },

  async create(property: PropertyCreate): Promise<Property> {
    const { data } = await axiosInstance.post<Property>(API_ENDPOINTS.PROPERTIES, property)
    return data
  },

  async update(id: number, property: PropertyUpdate): Promise<Property> {
    const { data } = await axiosInstance.put<Property>(API_ENDPOINTS.PROPERTY_BY_ID(id), property)
    return data
  },

  async delete(id: number): Promise<void> {
    await axiosInstance.delete(API_ENDPOINTS.PROPERTY_BY_ID(id))
  },
}
